// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type UnteraufgabenListe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export type SearchUnteraufgabenQuery = {
  search?: string;
  filtered?: string;
  page?: number;
  limit?: number;
  sort?: string;
};

export function useSearchUnteraufgaben(): (
  aufgabeId: string,
  query: SearchUnteraufgabenQuery
) => Promise<UnteraufgabenListe> {
  const getAPI = useGetApi();
  return useCallback(
    async (aufgabeId, query = {}) =>
      (await getAPI()).unteraufgaben.searchUnteraufgaben({
        aufgabeId,
        ...query,
      }),
    [getAPI]
  );
}
